import { factory, getResponseCamelization } from '@repo-level/core-front';
import type { CMSGroupParams, CMSImageBase } from './base';
import { buildCmsUrl, getResponseCMS } from './base';

export type TPrizeType = 'cp' | 'fs' | 'cash';

export interface IMissionCard extends CMSGroupParams {
  shortTitle: string;
  longTitle?: string;
  backendId?: string;
  description?: string;

  button1Text: string;
  button1Link: string;
  button2Text: string;
  button2Link: string;

  itemImg: CMSImageBase;
  prizeType?: TPrizeType;
  prizeAmount?: number;

  groupKeyId?: string;

  realTimeProgress?: boolean;

  progress: number;
}

export interface IMissionBlock extends IMissionCard {
  title: string;
  description?: string;
  sectionMissions_1: IMissionCard[];
  sectionMissions_2: IMissionCard[];
  sectionMissions_3: IMissionCard[];
  showVipLabel?: boolean;
  onlyGuestAvailable?: boolean;
  identifier?: string;
  sectionMissionsTitle_2: string;
  sectionMissionsTitle_3: string;
}

export interface TermsMissions extends CMSGroupParams {
  id: number;
  title: string;
  text: string;
  identifier?: string;
}

export interface IMissions extends IMissionBlock {
  title: string;
  desktopBg: CMSImageBase;
  mobileBg: CMSImageBase;
  missionsBlocks: IMissionBlock[];
  termsAndConditions: TermsMissions[];
}

export const getMissionsCMS = factory(
  (r) => (lang: string) =>
    r<IMissions>(
      'get',
      buildCmsUrl({
        path: 'lucky-quest',
        lang,
        additionalParams: { populate: 'deep' },
      }),
      undefined,
      { transformResponse: [getResponseCamelization(), getResponseCMS] }
    )
);
